import { useState, useEffect } from 'react';
import { Table } from '../components/table-pagination-sorting/components/Table';
import { PaginatingAndSortingProps } from '../components/table-pagination-sorting/interfaces/interfaces';
import { useDoneFetchActions } from "../hooks/useDoneFetchActions";
import { reporteGeneral1 } from "../services/reportesServices";
import { PlantaFechas, PlantaFechaFilterProps } from '../components/others/Filters/PlantaFechas';
import { useLocation } from 'react-router-dom';
import { PATHS, TABLES_TITLES } from '../utils/Constant';
import { tableComponentComplet } from '../utils/formsInitialsStates';
import { dateToInput } from '../utils/utility';
import { sendPesosToErp } from '../services/erpServices';
import { useAppDispatch } from '../store/store';
import { showMessage } from '../reducers/msgReducer';

export const Reportes = () => {
  const doneFetchActions = useDoneFetchActions();
  const dispatch = useAppDispatch();
  const tipoReporte = useLocation().pathname.split('/')[1];
  const isConsolidadoProveedor = tipoReporte === PATHS.REPORTES.CONSOLIDADO_PROVEEDOR;

  const [data, setData] = useState({ count: 0, titles: TABLES_TITLES[tipoReporte] } as tableComponentComplet)
  const [filterData, setDataFilter] = useState({
    fechaFin: dateToInput(),
    fechaIni: dateToInput(),
  } as filtersProps);
  const [isSendingErp, setIsSendingErp] = useState(false);
  interface filtersProps extends PaginatingAndSortingProps, PlantaFechaFilterProps { }

  useEffect(() => {
    doneFetchActions(reporteGeneral1(filterData, undefined, tipoReporte))
      .then((data) => {
        setData(() => {
          const titles = [...TABLES_TITLES[tipoReporte]];
          if (!data?.rows) data = { count: 0, titles, rows: [] }
          if (tipoReporte === PATHS.REPORTES.ESTRACTO_D_PROVEEDOR) {
            titles.splice(3, 0, ...Object.keys(data?.rows?.[0] || [])
              .filter(key => /^\d{4}-\d{2}-\d{2}$/.test(key))
              .map(name => ({ sort: name, title: name })));
          }
          return { ...data, titles }
        });
      });
  }, [filterData, doneFetchActions, tipoReporte])

  const handleChangeTable = (pageAction: PaginatingAndSortingProps) => {
    setDataFilter((dt) => ({ ...dt, ...pageAction }));
  }
  const handleSubmit = (dataFilter: PlantaFechaFilterProps) => {
    setDataFilter((dt) => ({ ...dt, ...dataFilter }));
  }
  const handleSendToErp = () => {
    setIsSendingErp(true);
    doneFetchActions(sendPesosToErp(filterData))
      .then((resp) => {
        dispatch(showMessage({
          isShow: true,
          body: resp?.message || 'Información enviada correctamente al ERP.',
          type: 'success'
        }));
      })
      .catch(() => null)
      .finally(() => setIsSendingErp(false));
  };
  function downReport(type: string) {
    doneFetchActions(reporteGeneral1(filterData, type, tipoReporte))
  }
  return (
    <div>
      <div className='d-flex justify-content-center pt-4'>
        <h4 className="text-center mb-4">
          {
            {
              [PATHS.REPORTES.CONSOLIDADO_PROVEEDOR]: "Consolidado de proveedores",
              [PATHS.REPORTES.ESTRACTO_D_PROVEEDOR]: "Extracto diario de proveedores"
            }[tipoReporte]
          }
        </h4>
      </div>
      <div className="row justify-content-center">
        <PlantaFechas runSearch={handleSubmit} initialValuesFilter={filterData}
          hideIntervalo={true} /* Evidelis lo colocó - Esto asegura que no se muestre el selector de intervalo en esta página*/ />

      </div>
      <h5 className="text-end bg-secondary rounded-3 px-4 py-1 text-white">Total de Litros: {data.info?.pesajeTotal || '0.0'}</h5>
      <Table dataTable={data} onChange={handleChangeTable} />
      <div className='d-flex gap-2 justify-content-end'>
        {isConsolidadoProveedor && (
          <button onClick={handleSendToErp} disabled={isSendingErp} className='btn btn-info'>Envío a ERP</button>
        )}
        <button onClick={() => downReport('csv')} className='btn btn-success'>CSV</button>
        <button onClick={() => downReport('pdf')} className='btn btn-danger'>PDF Simplificado</button>
        <button onClick={() => downReport('pdf-extendido')} className='btn btn-warning'>PDF Extendido</button>

      </div>
    </div>
  )
}
